import './download.css';
import downloadImg from './../../img/images/vouchers-img.png';
import iOs from './../../img/icons/app-store.png';
import android from './../../img/icons/google-play.png';

const Download = () => {
   return (
      <section className="download">
         <div className="container">
            <div className="download__content">
               <div className="download__text">DOWNLOAD APP & GET THE VOUCHER!
                  <p className="download__sub-text">Get 30% off for first transaction using Rondovision mobile app for now.</p>
                  <div className="download__btn">
                     <a href="#!" className="download__link">
                        <img src={iOs} alt="" />
                     </a>
                     <a href="#!" className="download__link">
                        <img src={android} alt="" />
                     </a>
                  </div>
               </div>
               <div className="download__img">
                  <img src={downloadImg} alt="" />
               </div>
            </div>
         </div>
      </section>
   );
}

export default Download;